import { $ } from '@utils';

function init() {
  if (!$('[data-au-scroll-progress]')) return;

  setScrollProgress();
}

function setScrollProgress() {
  const scrollProgress = $('[data-au-scroll-progress]');
  const scrollProgressBar = $('[data-au-scroll-progress-bar]');
  const header = $('.n-main-header-responsive');

  if (header) {
    header.appendChild(scrollProgress);
  } else {
    document.body.appendChild(scrollProgress);
    scrollProgress.classList.add('au-scroll-progress--fixed');
  }

  window.addEventListener('scroll', function () {
    const footerHeight = $('footer') ? $('footer').offsetHeight : 0;
    const breadcrumbsHeight = $('[data-au-breadcrumbs]')
      ? $('[data-au-breadcrumbs]').closest('section').offsetHeight
      : 0;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight - footerHeight - breadcrumbsHeight;
    const scroll = window.scrollY;
    const scrollPercentage = (scroll / docHeight) * 100;

    scrollProgressBar.style.width = `${scrollPercentage}%`;
  });
}

export default { init };
